module.exports = __webpack_public_path__ + "static/media/arrow-right.d258077c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/arrow-right.svg
// module id = 472
// module chunks = 1